import { Injectable } from '@angular/core';
import { FirestoreService, Params } from './firebase/firestore.service';
import { COLLECTION_NAMES } from '@libs/constants/collections.const';
import { BehaviorSubject } from 'rxjs';
import { Tenant } from '@libs/models/tenant.models';

@Injectable({ providedIn: 'root' })
export class TenantService extends FirestoreService {
    constructor() {
        super();

        this.setCollectionRef(COLLECTION_NAMES.TENANT);
    }

    public currentTenant: BehaviorSubject<Tenant | null> = new BehaviorSubject<Tenant | null>(null);

    public async setTenant(tenantId?: string) {
        if (tenantId) {
            const tenant = await this.get(tenantId);

            if (tenant) {
                this.currentTenant.next(tenant);
            }

            return;
        }

        this.currentTenant.next(null);
    }

    public async getTenantByDomain(domain: string) {
        const params: Params = {
            where: [{
                key: 'subdomain', condition: '==', value: domain
            }]
        };

        const tenant = await this.load(params);
        return tenant[0] as Tenant;
    }
}